import AddSupportPage from "../../../component/users/support/AddSupportPage"

 
 
function EditUserSupport() {
  return (
    <div className="page-body"><AddSupportPage/></div>
  )
}

export default EditUserSupport